"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const react_transition_group_1 = require("react-transition-group");
const styled_1 = __importDefault(require("../../styles/styled"));
const buttons_1 = require("../buttons");
const icons_1 = require("../icons");
const layout_1 = require("../layout");
const typography_1 = require("../typography");
const Snackbar = ({ content, position, onPauseSnackTimeout, onResumeSnackTimeout, isTrayOpen, }) => {
    const snackRef = (0, react_1.useRef)();
    const classes = {
        enter: 'fade-enter',
        enterActive: 'fade-enter-active',
        exit: 'fade-exit',
        exitActive: 'fade-exit-active',
    };
    return ((0, jsx_runtime_1.jsx)(layout_1.Box, Object.assign({ className: "snackbar", ref: snackRef }, { children: (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(TransitionComponent, Object.assign({ vertical: position.vertical, horizontal: position.horizontal, istrayopen: isTrayOpen ? 'true' : null }, { children: content.map(({ id, message, actionMessage, icon, level, timeout, backgroundColor, onActionClick, useCloseButton, }) => {
                const ref = (0, react_1.createRef)();
                return ((0, jsx_runtime_1.jsx)(TransitionWrapper, Object.assign({ classes: classes, classNames: "fade", timeout: 300, nodeRef: ref, unmountOnExit: true }, { children: (0, jsx_runtime_1.jsx)(SnackBarWrapper, Object.assign({ ref: ref, role: "status" }, { children: (0, jsx_runtime_1.jsx)(SnackBarContent, { backgroundColor: backgroundColor, message: message, actionMessage: actionMessage, icon: icon, id: id, level: level, onPauseSnackTimeout: onPauseSnackTimeout
                                ? () => onPauseSnackTimeout(id)
                                : null, onResumeSnackTimeout: onResumeSnackTimeout
                                ? () => onResumeSnackTimeout(id, timeout)
                                : null, onActionClick: () => onActionClick ? onActionClick(id) : null, useCloseButton: useCloseButton }) })) }), id));
            }) })), document.body) })));
};
exports.Snackbar = Snackbar;
const SnackBarContent = ({ message, actionMessage, icon, level = 'info', onPauseSnackTimeout, onResumeSnackTimeout, backgroundColor, onActionClick, useCloseButton = false, }) => {
    const defaultIconMapping = {
        info: (0, jsx_runtime_1.jsx)(icons_1.AppIcon, { name: "InformationIcon" }),
    };
    return ((0, jsx_runtime_1.jsxs)(SnackBarContentWrapper, Object.assign({ backgroundColor: backgroundColor, onMouseEnter: onPauseSnackTimeout, onFocus: onPauseSnackTimeout, onMouseLeave: onResumeSnackTimeout, onBlur: onResumeSnackTimeout }, { children: [icon !== false ? (0, jsx_runtime_1.jsx)(IconWrapper, { children: icon || defaultIconMapping[level] }) : null, (0, jsx_runtime_1.jsx)(layout_1.Box, Object.assign({ padding: "8px 0" }, { children: (0, jsx_runtime_1.jsx)(typography_1.AppText, Object.assign({ fontFamily: "ASAP, sans-serif", fontSize: 12 }, { children: message })) })), (actionMessage || useCloseButton) && ((0, jsx_runtime_1.jsx)(SnackBarContentAction, { children: useCloseButton ? ((0, jsx_runtime_1.jsx)(buttons_1.IconButton, { iconName: "CloseIcon", size: "medium", label: "close", onClick: () => onActionClick(), background: 'transparent' })) : ((0, jsx_runtime_1.jsx)(buttons_1.Button, Object.assign({ onClick: () => onActionClick(), variant: "tertiary", "aria-label": actionMessage, role: "button" }, { children: actionMessage }))) }))] })));
};
const SnackBarContentAction = styled_1.default.div(() => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8,
}));
const SnackBarContentWrapper = styled_1.default.div(({ theme, backgroundColor }) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexGrow: 1,
    padding: '10px 16px',
    borderRadius: '8px',
    backgroundColor: backgroundColor || theme.colors.white,
    minWidth: '178px',
}));
const IconWrapper = styled_1.default.div(() => ({
    display: 'flex',
    marginRight: '8px',
}));
const SnackBarWrapper = styled_1.default.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: theme.shadow.bottomLarge,
    marginBottom: '16px',
}));
const TransitionWrapper = (0, styled_1.default)(react_transition_group_1.CSSTransition)(({ classes }) => ({
    position: 'relative',
    [`&.${classes.enter}`]: {
        opacity: 0,
    },
    [`&.${classes.enterActive}`]: {
        opacity: 1,
        transition: 'opacity 300ms, transform 300ms',
    },
    [`&.${classes.exit}`]: {
        opacity: 1,
    },
    [`&.${classes.exitActive}`]: {
        opacity: 0,
        transition: 'opacity 300ms, transform 300ms',
    },
}));
const TransitionComponent = (0, styled_1.default)(react_transition_group_1.TransitionGroup)(({ horizontal, vertical, istrayopen }) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({ position: 'fixed', zIndex: 1400 }, (vertical === 'top' ? { top: '24px' } : { bottom: '24px' })), (horizontal === 'center' &&
        (istrayopen
            ? { left: 'calc(50vw + 256px)', transform: 'translateX(-64%)' }
            : { left: '50%', transform: 'translateX(-50%)' }))), (horizontal === 'left' && { left: '24px', right: 'auto' })), (horizontal === 'right' && { right: '24px', left: 'auto' }));
});
//# sourceMappingURL=snackbar.js.map